import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class FlightReportOfflineEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      show_select_clients: 0,
      id: this.props.flight_report_id,
      aircraft: this.props.flight_report.aircraft,
      base: this.props.flight_report.base,
      contract: this.props.flight_report.contract,
      flight_type: this.props.flight_report.flight_type,
      staff_sigmec: this.props.flight_report.staff_sigmec,
      client_name: this.props.flight_report.client_name,
      date: this.props.flight_report.date_str,
      flight_number: this.props.flight_report.flight_number,
      exemption: this.props.flight_report.exemption,
      exemption_str: this.props.flight_report.exemption_str,
      observations: this.props.flight_report.observations,
    };

  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.date === 'undefined' || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        id: newProps.id,
        aircraft_id: newProps.flight_report.aircraft_id,
        base: newProps.flight_report.base,
        contract: newProps.flight_report.contract,
        flight_type: newProps.flight_report.flight_type,
        staff_sigmec: newProps.flight_report.staff_sigmec,
        client_name: newProps.flight_report.client_name,
        show_select_clients: newProps.flight_report.show_select_clients,
        date: newProps.flight_report.date_str,
        flight_number: newProps.flight_report.flight_number,
        exemption: newProps.flight_report.exemption,
        exemption_str: newProps.flight_report.exemption_str,
        observations: newProps.flight_report.observations,
        loaded: 1,
      });
      if(!newProps.flight_report.flight_number || newProps.flight_report.flight_number === null) {
        this.setState({
          flight_number: '',
        });
      }
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    if(navigator.onLine) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.id,
        aircraft_id: this.state.aircraft_id,
        base_id: this.state.base_id,
        contract_id: this.state.contract_id,
        flight_type_id: this.state.flight_type_id,
        staff_sigmec_id: this.state.staff_sigmec_id,
        client_id: this.state.client_id,
        date: this.state.date,
        flight_number: this.state.flight_number,
        exemption: this.state.exemption,
        observations: this.state.observations,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    } else {
      window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
    }
    
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
        <div className="row">
            <div className="col-md-3 form-group">
                <label>Data:</label>
                <br/>
                {this.state.date}
            </div>
            <div className="col-md-3 form-group">
                <label>Prefixo:</label>
                <br/>
                {this.state.aircraft}
            </div>
            <div className="col-md-3 form-group">
                <label>Voo:</label>
                <br/>
                {this.state.flight_type}
            </div>
            <div className="col-md-3 form-group">
                <label>Número de voo:</label>
                <br/>
                {this.state.flight_number}
            </div>
        </div>
        <br/>
        <div className="row">
            <div className="col-md-3 form-group">
                <label>Solicitou isenção</label>
                <br/>
                {this.state.exemption_str}
            </div>
            <div className="col-md-3 form-group">
                <label>Base:</label>
                <br/>
                {this.state.base}
            </div>
            <div className="col-md-3 form-group">
                <label>Contrato:</label>
                <br/>
                {this.state.contract}
            </div>
            <div className="col-md-3 form-group">
                <label>Mecânico responsável:</label>
                <br/>
                {this.state.staff_sigmec}
            </div>
        </div>
        {(this.state.show_select_clients == 1) ?
            <div className="row">
                <div className="col-md-3 form-group">
                    <label>Cliente</label>
                    <br/>
                    {this.state.client_name}
                </div>
            </div>
        : '' }
        <hr/>
</div>
    );
  }
}

export default FlightReportOfflineEditTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportOfflineEditTab.js